<template>
  <van-popup v-model="showBind" class="backRect" @closed="onClosed">
    <TopBar :pagetitle="title" :is-left-self="true" @leftClick="onBack" />
    <div class="inputRect">
      <van-field
        v-model="phone"
        required
        clearable
        label="手机号码"
        placeholder="请输入11位手机号码"
      >
        <template #button>
          <van-button size="small" :color="GetColorMain()" :disabled="phone==='' || sendDisable" :loading="sendLoading" type="primary" @click="onSendHashCode">{{ sendTime === 0?'发送验证码':'['+sendTime+']' }}</van-button>
        </template>
      </van-field>
      <van-field
        v-model="code"
        :readonly="phone===''"
        required
        clearable
        label="验证码"
        placeholder="请输入6位数手机验证码"
      />

      <div class="buttonRect">
        <van-button type="primary" size="large" :disabled="code===''" :loading="buttonLoading" :color="GetColorMain()" @click="onBindPhone">绑定</van-button>
      </div>
    </div>
    <div v-if="showType==='reg'" class="regAbout">
      绑定手机号码即可关联预定行程订单,接收行程通知等。
    </div>
  </van-popup>

</template>
<script>
import request from '@/utils/request'
import TopBar from '@/components/TopBar'
import { Button, Popup, Field, Toast } from 'vant'
import { getUserBase } from '@/utils/base'
import { MyNotify, GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [Toast.name]: Toast,
    TopBar
  },
  props: {
    // eslint-disable-next-line
    value:undefined,
    // eslint-disable-next-line
    showType:undefined
  },
  data() {
    return {
      title: '绑定手机号',
      showBind: false,
      buttonLoading: false,
      sendLoading: false,
      sendDisable: false,
      phone: '',
      code: '',
      sendTime: 0,
      sendMaxTime: 120,
      sendInterval: undefined
    }
  },
  watch: {
    value(newValue) {
      if (newValue) {
        getUserBase(data => {
          if (!data) {
            return
          }
          if (data.bindPhone) {
            this.$emit('finish')
            this.showBind = false
            return
          }
          this.init()
          this.showBind = true
        }, true)
      } else {
        this.showBind = false
      }
    }
  },
  created() {

  },
  methods: {
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    init() {
      if (this.showType === 'reg') {
        this.title = '注册账号'
      }
    },
    onClosed() {
      this.$emit('input', false)
    },
    onBack() {
      this.showBind = false
      return true
    },
    onSendHashCode() {
      if (!this.phone) {
        MyNotify('error', '请输入11位手机号码')
        return
      }
      this.phone = this.phone.trim()
      if (this.phone.length !== 11) {
        MyNotify('error', '请输入11位手机号码')
        return
      }
      this.sendLoading = true
      request({
        url: '/user/sendBindHashCode',
        method: 'post',
        data: {
          phoneArea: '86',
          phone: this.phone
        }
      }).then(response => {
        this.sendLoading = false
        if (!response.success) {
          return
        }
        this.sendDisable = true
        this.sendTime = this.sendMaxTime
        this.sendInterval = setInterval(() => {
          this.sendTime--
          if (this.sendTime <= 0) {
            clearInterval(this.sendInterval)
            this.sendDisable = false
            this.sendTime = 0
          }
        }, 1000)
      })
    },
    onBindPhone() {
      this.buttonLoading = true
      request({
        url: '/user/checkBindHashCode',
        method: 'post',
        data: {
          phoneArea: '86',
          phone: this.phone,
          hashCode: this.code
        }
      }).then(response => {
        this.buttonLoading = false
        if (!response.success) {
          return
        }
        Toast.success('手机号码绑定成功!')
        this.showBind = false
        getUserBase(data => {
          if (!data) {
            return
          }
          data.bindPhone = true
          data.phone = this.phone
          data.phoneArea = '86'
        }, true)
        this.$emit('reload')
      })
    }

  }
}
</script>
<style scoped>
.backRect{
    width: 100vw;
    height: 100vh;
    background-color: #F1f1f1;
}
.inputRect{
  margin: 1em 1em 0 1em;
  background-color: #fff;
  border-radius: 0.5em;
  overflow: hidden;
}
.regAbout{
  margin:1em 2em;
  color: #999;
  font-size: 0.8em;
}
</style>
